<template>
  <h2 class="content-block">Bulk Operations</h2>

  <div class="content-block">
    <p class="intro muted">
      Import or update master data in bulk from an Excel or CSV file. Choose an
      operation below to get started.
    </p>

    <div class="op-grid">
      <div
        v-for="op in operations"
        :key="op.key"
        class="op-card dx-card"
        :class="{ disabled: !op.enabled }"
        @click="select(op)"
      >
        <div class="op-card-head">
          <i class="dx-icon" :class="op.icon"></i>
          <span class="op-title">{{ op.title }}</span>
        </div>
        <p class="op-desc muted">{{ op.description }}</p>
        <div class="op-foot">
          <span v-if="op.enabled" class="chip">{{ op.action }}</span>
          <span v-else class="chip chip-muted">Coming soon</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import notify from "devextreme/ui/notify";

export default {
  name: "BulkOperations",
  data() {
    return {
      operations: [
        {
          key: "site-create",
          title: "Bulk Site Creation",
          description:
            "Upload a spreadsheet of new sites and create them one row at a time. Rows are validated before submission and each row reports its own success or error.",
          icon: "dx-icon-add",
          action: "Create sites",
          route: "/bulk-operations/site-create",
          enabled: true,
        },
        {
          key: "site-update",
          title: "Bulk Site Updates",
          description:
            "Upload a spreadsheet of existing sites to change names, operators, areas or properties against the records already in the system.",
          icon: "dx-icon-edit",
          action: "Update sites",
          route: "/bulk-operations/site-update",
          enabled: false,
        },
        {
          key: "device-create",
          title: "Bulk Device Creation",
          description:
            "Upload a spreadsheet of new devices — serial numbers, device types and contracts — and register them against existing sites.",
          icon: "dx-icon-tips",
          action: "Create devices",
          route: "/bulk-operations/device-create",
          enabled: false,
        },
        {
          key: "device-update",
          title: "Bulk Device Updates",
          description:
            "Upload a spreadsheet of existing devices to change their type, contract or status, or to move them between sites.",
          icon: "dx-icon-preferences",
          action: "Update devices",
          route: "/bulk-operations/device-update",
          enabled: false,
        },
      ],
    };
  },
  methods: {
    select(op) {
      if (!op.enabled) {
        notify(`${op.title} is not available yet.`, "info", 2000);
        return;
      }
      this.$router.push(op.route);
    },
  },
};
</script>

<style scoped>
.intro {
  margin: 0 0 20px 0;
  max-width: 720px;
}

.op-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.op-card {
  display: flex;
  flex-direction: column;
  padding: 18px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.08s ease;
}

.op-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
}

.op-card.disabled {
  cursor: default;
  opacity: 0.55;
}

.op-card.disabled:hover {
  transform: none;
  box-shadow: none;
}

.op-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.op-card-head .dx-icon {
  font-size: 20px;
  color: rgb(255, 125, 0);
}

.op-title {
  font-size: 16px;
  font-weight: 500;
}

.op-desc {
  flex: 1 1 auto;
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 14px 0;
}

.op-foot {
  display: flex;
}

.chip {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(255, 115, 0, 0.15);
  color: rgb(255, 140, 40);
}

.chip-muted {
  background: rgba(150, 150, 150, 0.15);
  color: rgb(160, 160, 160);
}

.muted {
  opacity: 0.7;
}
</style>
